/**
 * Post carrier informations
 *
 **/
import { Injectable } from '@angular/core';
 // Import RxJs required methods
 
 

 @Injectable()
 export class CarrierService {

     private $post = JSON.parse(sessionStorage.getItem('$post'));

     private carrier: any;

     getCarrier(_searchRQ: any) : void{
         this.carrier = _searchRQ.carrier;
         return this.carrier;
     }


 }
